import React from 'react';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import Root from './pages/root';
import { LiveLoader } from './components/live-loader';
import { ScriptLoader } from './components/script-loader';

import store from './store';

const getElement = (elOrId) => {
  if (!elOrId) throw Error('Element or an id if required');
  if (typeof elOrId === 'string') {
    const id = elOrId.replace('#', '');
    const div = document.getElementById(id);
    if (!div) throw Error("Couldn't find an element with id:" + id);
    return div;
  }
  return elOrId;
};

const getRenderer = (div) => (Component) => {
  render(
    <ScriptLoader>
      <React.Fragment>
        <LiveLoader />
        <Provider store={store}>
          <Component />
        </Provider>
      </React.Fragment>
    </ScriptLoader>,
    div
  );
};

const createEmbed = (id) => {
  var div = getElement(id);
  const renderer = getRenderer(div);
  renderer(Root);
};

window._smuCreateEmbed = createEmbed;



// WEBPACK FOOTER //
// ./src/create-embed.js